// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__R_kkv","headerLink":"Header_headerLink__ZBzY9"};